import { Block, useBlockRenderer } from '@/hooks/use-block-renderer'
import { BlockRenderer } from '@/Components/block-renderer'

export default function Contact() {
  const blocks = useBlockRenderer('contact') as Block[]
  return <BlockRenderer blocks={blocks} />
}
